<template>
    <section>
      <el-form ref="form" label-position="right" status-icon :model="form" :rules="rules" label-width="150px" style="width:95%;overflow:auto">
        <el-form-item label="是否为双向感应" prop="id">
          <div>
            <el-radio-group v-model="form.isTwo">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="主设备编号" prop="id">
          <el-input placeholder="请输入主设备编号" v-model="form.id" :disabled="row ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="副设备编号" prop="auxiliaryInductorId" v-if="form.isTwo == 1">
          <el-input placeholder="请输入副设备编号" v-model="form.auxiliaryInductorId" :disabled="row ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="主 → 副" prop="directionType" v-if="form.isTwo == 1">
          <div>
            <el-radio-group v-model="form.directionType">
              <el-radio :label="0">进入</el-radio>
              <el-radio :label="1">离开</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="所属商户" prop="merchantId" v-if="userInfo.roleLevel < 5 && ( (row && !row.merchantId) || !row)">
          <el-select v-model="form.merchantId" placeholder="请选择所属商户" @change="chooseMerchant">
            <el-option
              v-for="item in managerUnitOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装小区" prop="unitId"  v-if="userInfo.roleLevel <= 5">
          <el-select filterable remote v-model="form.unitId" clearable placeholder="请输入小区名称查询" :remote-method="getNieghbourList">
            <el-option
              v-for="item in neighbourhoodList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区内具体安装位置" prop="adders">
          <el-input placeholder="请填写具体安装位置" v-model="form.adders"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="handleSubmit('form')" :plain='true'>提交</el-button>
        </el-form-item>
      </el-form>
    </section>
  </template>
  
  <script>
  import { createInductor,updateInductor,getNeighbourhoodList,getPageHardwareVersion,getListSoftwareVersion,getMerchantList } from "@/api/public.js";
  export default {
    props:['row'], // 父组件携带参数
    data() {
      return {
        form:{ // 表单数据
          unitId:'',
          adders: "",
          id: "",
          type: "",
          merchantId:"",
          isTwo:'',
          way:'',
        },
        neighborList:[],//小区列表
        neighbourhoodList:[], // 小区选项
        hardWareVersionOptions:[], // 硬件版本号选项
        versionOptions:[], // 软件版本号选项
        typeOptions:[ // 感应器类型选项
          {label:1,text:'停放区'},
          {label:2,text:'临时停放区'},
          {label:3,text:'禁行区'},
        ],
        statusOptions:[
          {label:0,text:'掉线'},
          {label:1,text:'在线'},
        ],  // 感应器状态选项
        open: false, // 选择地址弹框是否显示
        rules: { // 表单验证
          id:[
            { required: true, message: '设备编号不得为空', trigger: 'blur', }
          ],
          unitId:[
            { required:true,message:'安装小区不得为空',trigger:"blur"}
          ],
          adders:[
            { required:true,message:'安装位置不得为空',trigger:"blur"}
          ],
          type:[
            { required:true,message:'感应器类型不得为空',trigger:"change"}
          ],
        },
        userInfo:JSON.parse(localStorage.getItem('userInfo')),
        managerUnitOptions:[], // 商户选项
      };
    },
  
    components: {},
  
    computed: {},
  
    mounted() {
      this.form = this.row ? {...this.row} : this.form;
      this.getNieghbourList("");
      this.getMerchantOptions();
      this.getHardwareVersion();
    },
  
    methods: {
      // 获取小区列表
      getNieghbourList(e){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:e,
            merchantId:this.form.merchantId,
          }
        }
        getNeighbourhoodList(data).then(res=>{
          if(res.success){
            this.neighbourhoodList = res.data.list;
          }
        })
      },
      // 获取商户列表
      async getMerchantOptions(){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:'',
          }
        }
        await getMerchantList(data).then(res=>{
          if(res.success){
            this.managerUnitOptions = res.data.list;
          }else{
            this.managerUnitOptions = [];
          }
        })
      },
      // 选择商户、小区
      chooseMerchant(e){
        this.form.merchantId = e;
        this.getNieghbourList();
      },
      // 获取硬件版本号列表
      getHardwareVersion(){
        getPageHardwareVersion({param:2}).then(res=>{
          if(res.success){
            this.hardWareVersionOptions = res.data;
          }
        })
      },
      // 获取软件版本号列表
      async searchVersion(e){
        let data = {
          pageNo:1,
          pageSize:10,
          param:{
            hardwareId:this.form.hardWareVersion,
            status:true,
            // version:e
          }
        }
        await getListSoftwareVersion(data).then(res=>{
          if(res.success){
            this.versionOptions = res.data.list;
          }else{
            this.versionOptions = [];
          }
        })
      },
      // 选择硬件版本
      chooseHardWare(){
        this.searchVersion("");
      },
      // 关闭弹窗
      close(form){
         this.$emit('close');
      },
      async add(){
        await createInductor({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
              this.init();
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      async edit(){
        await updateInductor({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
              this.init();
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 提交
      handleSubmit(form) {
        if(this.userInfo.roleLevel >= 10){
          this.form.unitId = this.userInfo.unitId;
        }
         this.$refs["form"].validate(valid => {
            if (valid) {
                this.$confirm('确认提交吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  if(this.row){
                    this.edit();
                  }else{
                    this.add();
                  }
                })
            }else{
              return false;
            }
        });
      },
    }
  };
  </script>
  <style lang="scss" scoped>
  // 防止地图自动完成的对象被遮挡
  .tangram-suggestion {
      z-index: 9999 !important;
    }
   .el-drawer{
     overflow:auto !important;
   }
   ::v-deep .el-form-item__content{
    display: flex;
   }
   .map{
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 4px;
    width: 80px;
   }
   .avatar-uploader .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      border: 1px dashed #ccc;
      border-radius: 50%;
      overflow:hidden;
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  </style>
  